import React from 'react'
import products from '../SampleProducts'

class Home extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            //products: {products}.products.products.products,
            shoppingCart: "",
            total:"",
            tax: ""
        };
    }

    render(){
        return(
            <React.Fragment>

            <div className="bg-image text-primary header-image">
                <img src="./images/home/header.jpg" className="card-img" alt="..."/>
                <h1 className="center-image-text justify-content-center header-text">Zhang-Davis Store!</h1>
            </div>

            <div className="container-fluid">
                <div className='row'>
                    <div  >
                        <h2 className="text-secondary">How to use our sandbox</h2>
                    </div>
                    <div>
                        <p>This site uses local storage so if cleared all your store items will be lost</p>
                        <p>Items that you add will only be visible on your browser, this is a safe space for playng shops with a barcode scanner.</p>
                    </div>
                    
                </div>
            </div>
        </React.Fragment>
            

        )
    }
}

export default Home;
